/**
 * @generated SignedSource<<60f81fdf42ed800e95b1fd0728088524>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModalIntegrations_company$data = {
  readonly harvestEnabled: boolean | null;
  readonly unit4Enabled: boolean | null;
  readonly " $fragmentType": "TimeRegistrationModalIntegrations_company";
};
export type TimeRegistrationModalIntegrations_company$key = {
  readonly " $data"?: TimeRegistrationModalIntegrations_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeRegistrationModalIntegrations_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationModalIntegrations_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4Enabled",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "3e4a85aa04776d0de7ff2744e0473a3a";

export default node;
